module.exports = __webpack_public_path__ + "static/media/3.df07c007.svg";